import Colors from 'assets/Colors';
import Lang from 'assets/Lang';
import Styles from 'assets/Styles';
import BaseText from 'common/components/bases/BaseText';
import ModalEdit from 'common/components/modals/ModalEdit';
import BottomMenu from 'common/components/views/BottomMenu';
import IconButton from 'common/components/views/IconButton';
import Funcs from 'common/helpers/Funcs';
import Const from 'consts/Const';
import UIConst from 'consts/UIConst';
import moment from 'moment';
import React from 'react';
import { View } from 'react-native';
import MaterialCommunityIcons from 'react-native-vector-icons/MaterialCommunityIcons';
import MaterialIcons from 'react-native-vector-icons/MaterialIcons';
import Realms from 'realm/Realms';
import OrderItemModel from 'realm/models/OrderItemModel';
import OrderModel from 'realm/models/OrderModel';
import ProductModel from 'realm/models/ProductModel';
import FinancialUtils from 'utils/FinancialUtils';
import Configs from './Configs';

const { SALE, IMPORT, RETURN, RECIEPT, IMPORT_RETURN } = Const.ORDER_TYPE;

const OrderUtils = {
  canEditOrder: (order) => {
    const daysCanEdit = Funcs.convertNumber(Configs.orderSettings?.daysCanEdit ?? 180);
    if (!order?.createdAt || daysCanEdit < 0) return true;
    return moment().isSameOrBefore(moment(order.createdAt).add(daysCanEdit, 'days'));
  },

  compare2ProductForStat: (item, item1) => {
    // Bỏ qua so sánh theo phân loại, index
    item = { ...item };
    item1 = { ...item1 };
    if (!item.unitId) item.unitId = 0;
    if (!item1.unitId) item1.unitId = 0;
    if (!item.unitId && item.product?.unitId > 0) item.unitId = item.product?.unitId;
    if (!item1.unitId && item1.product?.unitId > 0) item1.unitId = item1.product?.unitId;
    let compare = item.id === item1.id && item.unitId === item1.unitId;
    return compare;
  },

  compare2ProductItem: (item, item1, cancelCheckIndex = false) => {
    item = { ...item };
    item1 = { ...item1 };
    if (!item.unitId) item.unitId = 0;
    if (!item1.unitId) item1.unitId = 0;
    if (!item.productTypeId) item.productTypeId = 0;
    if (!item1.productTypeId) item1.productTypeId = 0;
    if (!item.unitId && item.product?.unitId > 0) item.unitId = item.product?.unitId;
    if (!item1.unitId && item1.product?.unitId > 0) item1.unitId = item1.product?.unitId;
    let compare = item.id === item1.id && item.productTypeId === item1.productTypeId && item.unitId === item1.unitId;

    // Nếu check index, 2 index đều phải là số
    if (Configs.orderSettings.productSeparate && compare && !cancelCheckIndex && Funcs.isNumber(item.index) && Funcs.isNumber(item1.index)) {
      compare = compare && item.index === item1.index;
    }

    //  Chỗ này nếu sửa hãy check thật kỹ lại, vì nhiều trường hợp nó ko có giá trị, nếu tự động gán nó về 0 là SAI
    if (compare && Funcs.isNumber(item.amountType) && Funcs.isNumber(item1.amountType)) {
      compare = compare && item.amountType === item1.amountType;
    }
    return compare;
  },

  hasInvalidProductTypes: (items) =>
    (items || []).some((item) => {
      const productTypeId = item.productTypeId || 0;
      if (!productTypeId) return false;
      const productType = item.productType || item.types?.find((type) => type.id === productTypeId);
      const productId = item.productId || item.product?.id || item.id;
      return !productType || productType.id !== productTypeId || (productType.productId && productType.productId !== productId);
    }),

  uniqueItems(items) {
    const correctItems = [];
    for (let i = 0; i < items.length; i += 1) {
      const item = items[i];
      const find = correctItems.find((e) => OrderUtils.compare2ProductItem(item, e));
      if (!find) correctItems.push(items[i]);
      else {
        find.amount += item.amount;
      }
    }
    return correctItems;
  },

  getDetailOrder: (order) => {
    if (!Configs.online) order = Realms.convertToObject(order, OrderModel);
    let { type, surchargePayType, surcharge, promotions, hourlyMoney, from, to, extraFee, child, branch, slotId } = order;
    let totalMoney = 0;
    const { pointDiscount } = order;
    const isReturn = type === Const.ORDER_TYPE.RETURN || type === Const.ORDER_TYPE.IMPORT_RETURN;
    let orderItems = order.orderItems || order.items || [];
    orderItems = orderItems.map((item) => {
      if (!Configs.online) item = Realms.convertToObject(item, OrderItemModel);
      let { product, buyPrice, productType, unit, amount, price } = item;
      if (!product) return {};
      if (!Configs.online) product = Realms.convertToObject(product, ProductModel);
      const { id, sellPrice, sellPrice1, sellPrice2, name, vat } = product;
      if (buyPrice === null || buyPrice === undefined) buyPrice = product.buyPrice;
      totalMoney += amount * price;
      item.unitConvertUnit = unit;
      item.unit = unit?.name || product.unit?.name || '';
      let topping = item?.selectedToppings?.map((e) => e?.extra?.name)?.join('\n - ');
      if (topping?.length > 0) topping = ' - ' + topping;
      return { ...item, topping, name, id, vat, sellPrice: productType?.price || sellPrice, sellPrice1, sellPrice2, buyPrice };
    });
    if (hourlyMoney > 0) {
      totalMoney += hourlyMoney;
      let totalTime = moment(to).diff(moment(from), 'seconds');
      totalTime = totalTime / 60 / 60;
      order.totalTime = totalTime;
    }

    // Tính discount (money)
    if (order.discount > 0) order.moneyDiscount = (order.discount / totalMoney) * 100;
    else if (order.moneyDiscount > 0) order.discount = (order.moneyDiscount / 100) * totalMoney;
    const { moneyDiscount } = order;

    // Re calculator order money
    const gifts = [];
    let revenue = 0;
    let totalBuyPrice = 0;
    let totalAmount = 0;
    let logRevenueList = [];
    for (let i = 0; i < orderItems.length; i += 1) {
      let { name, amount, price, buyPrice, product, unitId, unitConvert, unit, gift, amountType, topping } = orderItems[i];
      // Nếu có đơn vị chuyển đổi => Tính lại giá nhập
      if (unitConvert?.value > 0 && product && unitId && unitId !== product?.unitId) buyPrice *= unitConvert?.value;
      const realPrice = price - (price * (moneyDiscount || 0)) / 100; // Tính giá thực tế sp = giá sp - Chiết khấu đơn hàng
      orderItems[i].realPrice = realPrice;
      totalAmount += amount;
      totalBuyPrice += amount * buyPrice;
      let productRevenue = amount * (realPrice - buyPrice);
      if (type === RETURN) productRevenue = -productRevenue;
      if (amountType === Const.ITEM_AMOUNT_TYPE.GIFT) name += ` (${Lang.promotion.gift})`;
      logRevenueList.push({ name, unit, buyPrice, price, realPrice, revenue: productRevenue, amount, discount: moneyDiscount, topping });
      revenue += productRevenue;

      // Nếu có gift, thì trừ đi
      if (gift?.id) {
        const { amount: giftAmount, unit: giftUnit, product: giftProduct, price: giftPrice, unitConvert: giftUnitConvert } = gift;
        const giftBuyPrice = giftUnitConvert?.value > 0 ? gift.buyPrice * giftUnitConvert?.value : gift.buyPrice;
        const giftRevenue = -giftAmount * giftBuyPrice;
        logRevenueList.push({
          name: giftProduct?.name + ` (${Lang.promotion.gift})`,
          unit: giftUnit,
          buyPrice: giftBuyPrice,
          price: giftPrice,
          realPrice: 0,
          revenue: giftRevenue,
          amount: giftAmount,
          discount: 0
        });
        revenue += giftRevenue;
        totalAmount += giftAmount;
        gifts.push(gift);
      }
      if (amountType === Const.ITEM_AMOUNT_TYPE.GIFT) gifts.push(orderItems[i]);
    }

    // Nếu người bán mất phụ phí => Lợi nhuận sẽ trừ đi phụ phí
    if (surchargePayType === 1) {
      logRevenueList.push({ name: Configs.billSettings.invoiceText?.surchargeText || Configs.invoiceSurchage, buyPrice: 0, price: 0, revenue: -surcharge, amount: 0 });
      revenue -= surcharge;
    }

    // Nếu có giảm giá tiền từ điểm tích luỹ thì trừ lợi nhuận đi
    if (pointDiscount > 0) {
      logRevenueList.push({ name: Lang.order.pointDiscount, buyPrice: 0, price: 0, revenue: -pointDiscount, amount: 0 });
      revenue -= pointDiscount;
    }

    const totalProductMoney = totalMoney;
    let vatPercent = 0;
    try {
      // Trừ giảm giá
      if (order.discount >= 0) totalMoney -= order.discount;
      if (order.pointDiscount > 0) totalMoney -= Funcs.convertNumber(order.pointDiscount);

      // Cộng phụ phí
      if (surcharge && surchargePayType !== 1) totalMoney += Funcs.convertNumber(surcharge);
      if (extraFee) totalMoney += extraFee;
      if (order.vat) {
        totalMoney += Funcs.convertNumber(order.vat);
        vatPercent = Funcs.formatNumber((order.vat / (totalProductMoney - (order.discount || 0))) * 100);
      }
      totalMoney = Funcs.convertNumber(totalMoney);
    } catch (err) {
      console.log('###', err);
    }

    // Debit
    const { id, myId, money, customer, paid, points, paymentType } = order;
    const newDebit = money - (paid || 0);
    let totalOldDebit = 0;
    let totalDebit = isReturn ? -newDebit : newDebit;
    if (Configs.online && customer) {
      const isProvider = customer.type === 1;
      const isIncreaseDebit = (isProvider && type === IMPORT) || (!isProvider && type === SALE);
      const debitChange = isIncreaseDebit ? newDebit : -newDebit;
      totalDebit = customer.debt || 0;
      totalOldDebit = id === 'TMP' ? totalDebit : totalDebit - debitChange;
      if (id === 'TMP') totalDebit += debitChange;
    } else if (customer?.orders) {
      const listOrder = customer.orders.filter((e) => !e.parentOrderId && e.id !== order.id);
      totalOldDebit = FinancialUtils.getTotalDebt(listOrder, customer);
      totalDebit = totalOldDebit + (isReturn ? -newDebit : newDebit);
    }
    let moneyMustPay = money;
    if (Configs.settings.showDebt) {
      moneyMustPay = isReturn ? totalOldDebit - money : totalOldDebit + money;
    }
    let pointReward = 0;
    if (points?.length > 0) {
      const find = points.find((e) => e.type === 0);
      pointReward = find?.point;
    }

    // promotions
    let promotionName = '';
    let promotionSku = '';
    if (promotions?.length > 0) {
      for (let i = 0; i < promotions.length; i += 1) {
        const e = promotions[i];
        promotionName += e.sku + '-' + e.name + (i > 0 ? ', ' : '');
        promotionSku += e.sku + (i > 0 ? ', ' : '');
      }
    }

    // Nếu tắt công nợ, và đã trả tiền, child = 0 thì thêm 1 cái child để log lịch sử thanh toán
    if (!Configs.orderSettings.debtActive && child?.length === 0 && type === SALE) {
      child.push({ id, myId, type: RECIEPT, money, paid, paymentType });
    }

    // Cập nhật child
    child = child?.map((e) => {
      e.financialInfo = FinancialUtils.getFinancialInfo(e);
      return e;
    });

    // Chuyển đổi tiền sang text
    const moneyText = !!Funcs.convertNumberToVietnameseText && Funcs.convertNumberToVietnameseText(moneyMustPay);

    // State
    const financialInfo = FinancialUtils.getFinancialInfo(order);
    let orderDetail = { ...order, gifts, pointReward, money: totalMoney, totalProductMoney, orderItems, totalDebit, totalAmount, moneyMustPay, totalOldDebit, revenue, child };
    orderDetail = { ...orderDetail, totalBuyPrice, promotionSku, promotionName, financialInfo, logRevenueList, moneyText, vatPercent };
    // Branch, slot
    if (branch && slotId > 0) {
      const slot = { slot: slotId, name: (branch.prefix || Lang.servicesSetting.prefixDefault) + ': ' + slotId };
      const find = branch?.data?.find((e1) => e1.slot === slotId);
      orderDetail.slot = { ...slot, ...find };
    }
    return orderDetail;
  },

  getDetailOrderSimple: (order) => {
    if (!Configs.online) order = Realms.convertToObject(order, OrderModel);
    let { moneyDiscount, surchargePayType, surcharge, discount, money, pointDiscount, type } = order;
    let orderItems = order.orderItems || order.items || [];
    let totalBuyPrice = 0;
    let totalAmount = 0;
    let revenue = 0;
    let totalVat = 0;
    let totalProductMoney = 0;
    const gifts = [];

    // Thêm vào mảng
    for (let i = 0; i < orderItems.length; i += 1) {
      const item = orderItems[i];
      if (item.gift?.id) gifts.push(item.gift);
    }

    // Tính lại discount nếu nó bị sai
    if (discount > 0 && moneyDiscount === 0) moneyDiscount = (discount / (discount + money)) * 100;

    // List
    orderItems = [...orderItems, ...gifts];
    orderItems = orderItems.map((item) => {
      if (!Configs.online) item = Realms.convertToObject(item, OrderItemModel);
      let { product, buyPrice, productType, price, unitId, unitConvert } = item;

      if (!product) return {};
      if (!Configs.online) product = Realms.convertToObject(product, ProductModel);
      const { id, sellPrice, sellPrice1, sellPrice2, name, vat } = product;
      if (buyPrice === null || buyPrice === undefined) buyPrice = product.buyPrice;

      // Nếu có đơn vị chuyển đổi => Tính lại giá nhập
      if (unitConvert?.value > 0 && product && unitId && unitId !== product?.unitId) buyPrice *= unitConvert?.value;
      item.realPrice = price - (price * (moneyDiscount || 0)) / 100;
      item = { ...item, name, id, vat, sellPrice: productType?.price || sellPrice, sellPrice1, sellPrice2, buyPrice, unit: product.unit?.name || '' };

      const { amount, realPrice } = item;
      totalAmount += amount;
      totalBuyPrice += amount * buyPrice;
      let productRevenue = amount * (realPrice - buyPrice);
      if (type === RETURN) productRevenue = -productRevenue;
      revenue += productRevenue;
      totalProductMoney += amount * price;
      if (vat > 0) totalVat += (item.vat / 100) * price * item.amount;
      return { ...item, revenue: productRevenue };
    });

    // Nếu người bán mất phụ phí => Lợi nhuận sẽ trừ đi phụ phí
    const financialInfo = FinancialUtils.getFinancialInfo(order);
    if (surchargePayType === 1 && surcharge > 0) revenue -= surcharge;
    if (pointDiscount > 0) revenue -= pointDiscount;
    return { ...order, orderItems, items: orderItems, totalBuyPrice, totalAmount, revenue, totalVat, totalProductMoney, financialInfo };
  },

  // Tra giá gần nhất của dòng hàng trong bảng giá từ LastPriceLoader. Key: productId-t{productTypeId}-u{unitId}
  getLastPrice: (lastPrices, item) => {
    if (!lastPrices || !item) return null;
    const unitConvert = item.unitConvert || item.unit;
    const isConvertUnit = unitConvert?.value > 0 || (item.unitId > 0 && item.product?.unitId > 0 && item.unitId !== item.product?.unitId);
    // Đơn vị gốc có thể đã lưu unitId = 0 hoặc unitId của sản phẩm => lấy giá của đơn mới nhất trong các key
    const unitIds = isConvertUnit ? [item.unitId || unitConvert?.id] : [0, item.unitId, item.product?.unitId];
    const baseKey = `${item.id}-t${item.productTypeId || 0}`;
    const lastPrice = unitIds
      .filter((unitId) => unitId >= 0)
      .map((unitId) => lastPrices[`${baseKey}-u${unitId}`])
      .filter(Boolean)
      .reduce((result, e) => (!result || e.orderId > result.orderId ? e : result), null);
    return lastPrice?.price > 0 ? Funcs.convertNumber(lastPrice.price) : null;
  },

  showMenuPrice: (choiceCustomer, tablePrice, callback, onPressLastPrice) => {
    BottomMenu.show([
      ...(onPressLastPrice ? [{ title: Lang.order.lastPrice, onPress: onPressLastPrice }] : []),
      ...(tablePrice && choiceCustomer?.customerGroup ? [{ title: choiceCustomer?.customerGroup?.name, onPress: callback('sellPrice', tablePrice) }] : []),
      { title: Lang.product.sellPrice, onPress: callback('sellPrice') },
      { title: Lang.product.sellPrice1, onPress: callback('sellPrice1') },
      { title: Lang.product.sellPrice2, onPress: callback('sellPrice2') }
    ]);
  },

  showItemMenu: async ({ product, isImport, lastPrice, onChangePrice = (price) => () => {}, onPressAddNote = () => {}, onPressSeparate, onPressRemove = () => {} }) => {
    let sellPrice = product?.productType ? product?.productType.price : product.sellPrice;
    let sellPrice1 = product.sellPrice1;
    let sellPrice2 = product.sellPrice2;
    const onPressCustomPrice = (type) => () => {
      BottomMenu.hide();
      ModalEdit.show({
        title: !type ? Lang.order.customPrice : Lang.order.customPrice1,
        isNumber: true,
        placeholder: !type ? Lang.order.customPrice : Lang.order.customPrice1,
        multiline: false,
        callback: (text) => {
          try {
            let price = parseFloat(text);
            if (type) {
              var percent = parseFloat(text);
              const currentPrice = isImport ? product.buyPrice : sellPrice;
              price = currentPrice - (currentPrice * percent) / 100;
            }
            onChangePrice(price)();
          } catch (err) {
            console.log('###', err);
          }
        }
      });
    };
    let menuList = [];
    const isLandscape = await Funcs.isDeviceOrientationLandscape();
    const width = isLandscape ? UIConst.SCALE * 120 : '40%';
    const styleButton = { flexDirection: 'column', width, marginBottom: UIConst.SCALE * 10 };
    const styleButton1 = { flexDirection: 'column', width: isLandscape ? UIConst.SCALE * 90 : '28%', marginBottom: UIConst.SCALE * 10 };
    let buyPrice = product.buyPrice;
    const unitConvert = product?.unitConvert || product?.unit;
    if (unitConvert?.value > 0) {
      buyPrice = buyPrice * unitConvert?.value;
      sellPrice = unitConvert?.price;
      sellPrice1 = sellPrice1 * unitConvert?.value;
      sellPrice2 = sellPrice2 * unitConvert?.value;
    }
    menuList.push({
      title: (
        <View style={{ flex: 1, paddingTop: UIConst.SCALE * 10 }}>
          <BaseText style={{ fontWeight: 'bold', marginBottom: UIConst.SCALE * 10, textAlign: 'center', flex: 1 }}>{Lang.product.priceType}</BaseText>
          <View style={{ flex: 1, flexDirection: 'row', flexWrap: 'wrap', ...Styles.center }}>
            {!isImport && (
              <>
                <IconButton style={styleButton} onPress={onChangePrice(sellPrice)}>
                  <BaseText numberOfLines={1} style={{ fontSize: UIConst.FIX_FONT_SIZE - 1 }}>
                    {Lang.product.sellPrice}
                  </BaseText>
                  <BaseText numberOfLines={1} adjustsFontSizeToFit style={{ fontSize: UIConst.FIX_FONT_SIZE, fontWeight: 'bold', color: Colors.colorApp }}>
                    {Funcs.formatCurency(sellPrice)}
                  </BaseText>
                </IconButton>
                <IconButton style={styleButton} onPress={onChangePrice(sellPrice1)}>
                  <BaseText numberOfLines={1} style={{ fontSize: UIConst.FIX_FONT_SIZE - 1 }}>
                    {Lang.product.sellPrice1}
                  </BaseText>
                  <BaseText numberOfLines={1} adjustsFontSizeToFit style={{ fontSize: UIConst.FIX_FONT_SIZE, fontWeight: 'bold', color: Colors.colorApp }}>
                    {Funcs.formatCurency(sellPrice1)}
                  </BaseText>
                </IconButton>
                <IconButton style={styleButton} onPress={onChangePrice(sellPrice2)}>
                  <BaseText numberOfLines={1} style={{ fontSize: UIConst.FIX_FONT_SIZE - 1 }}>
                    {Lang.product.sellPrice2}
                  </BaseText>
                  <BaseText numberOfLines={1} adjustsFontSizeToFit style={{ fontSize: UIConst.FIX_FONT_SIZE, fontWeight: 'bold', color: Colors.colorApp }}>
                    {Funcs.formatCurency(sellPrice2)}
                  </BaseText>
                </IconButton>
                {lastPrice > 0 && (
                  <IconButton style={styleButton} onPress={onChangePrice(lastPrice)}>
                    <BaseText numberOfLines={1} style={{ fontSize: UIConst.FIX_FONT_SIZE - 1 }}>
                      {Lang.order.lastPrice}
                    </BaseText>
                    <BaseText numberOfLines={1} adjustsFontSizeToFit style={{ fontSize: UIConst.FIX_FONT_SIZE, fontWeight: 'bold', color: Colors.colorApp }}>
                      {Funcs.formatCurency(lastPrice)}
                    </BaseText>
                  </IconButton>
                )}
                {Configs.isManagerApp && (
                  <IconButton style={styleButton} onPress={onChangePrice(buyPrice)}>
                    <BaseText numberOfLines={1} style={{ fontSize: UIConst.FIX_FONT_SIZE - 1 }}>
                      {Lang.product.buyPrice}
                    </BaseText>
                    <BaseText numberOfLines={1} adjustsFontSizeToFit style={{ fontSize: UIConst.FIX_FONT_SIZE, fontWeight: 'bold', color: Colors.colorApp }}>
                      {Funcs.formatCurency(buyPrice)}
                    </BaseText>
                  </IconButton>
                )}
              </>
            )}
            <IconButton style={{ ...styleButton, paddingVertical: UIConst.SCALE * 10 }} text={Lang.order.customPrice} onPress={onPressCustomPrice(0)} />
            <IconButton style={{ ...styleButton, paddingVertical: UIConst.SCALE * 10 }} text={Lang.order.customPrice1} onPress={onPressCustomPrice(1)} />
          </View>
        </View>
      )
    });

    // Thêm nút
    menuList.push({
      title: (
        <View style={{ flex: 1, paddingVertical: UIConst.SCALE * 10 }}>
          <BaseText style={{ fontWeight: 'bold', marginBottom: UIConst.SCALE * 10, textAlign: 'center' }}>{Lang.more}</BaseText>
          <View style={{ flex: 1, flexDirection: 'row', flexWrap: 'wrap', ...Styles.center }}>
            {Configs.orderSettings.productSeparate && !!onPressSeparate && (
              <IconButton
                style={{ ...styleButton1, flexDirection: 'row' }}
                icon={<MaterialIcons name={'call-split'} size={UIConst.SCALE * 20} color={Colors.text} />}
                text={Lang.order.separate}
                onPress={onPressSeparate}
              />
            )}
            <IconButton
              style={{ ...styleButton1, flexDirection: 'row' }}
              icon={<MaterialCommunityIcons name={'note-plus-outline'} size={UIConst.SCALE * 20} color={Colors.text} />}
              text={Lang.note}
              onPress={onPressAddNote}
            />
            <IconButton style={{ ...styleButton1, flexDirection: 'row' }} icon={'remove'} text={Lang.delete} onPress={onPressRemove} />
          </View>
        </View>
      )
    });
    BottomMenu.show(menuList, '', { isCustom: true });
  },

  applyPromotion: ({ selectedProducts, totalProductMoney, promotion, discountType }) => {
    Funcs.log('Promotion', promotion);
    const { type, data } = promotion;
    if (type === Const.PROMOTION_TYPES.PRODUCT) {
      selectedProducts = selectedProducts.map((e) => {
        const find = data.find((e1) => OrderUtils.compare2ProductItem(e1, { ...e, index: 0 }));
        e = { ...e, hasPromotion: !!find };
        if (find?.data?.length > 0) {
          const { data: priceLevels = [] } = find;
          priceLevels.sort((a, b) => a.quantity - b.quantity);
          let item = { price: 0 };
          for (let i = 0; i < priceLevels.length; i += 1) {
            if (e.amount >= priceLevels[i].quantity) item = priceLevels[i];
          }
          if (item?.price > 0) e.price = item?.price;
          Funcs.log('Promotion apply', find, item);
        }
        return e;
      });
      ////////////////////////////////////////////////////////////////// Lỗi khi có topping, đáng lẽ phải cộng tổng sản phẩm vào rồi tính giá
      return { selectedProducts, type };
    } else if (type === Const.PROMOTION_TYPES.ORDER) {
      let item = null;
      data.sort((a, b) => a.money - b.money);
      for (let i = 0; i < data.length; i += 1) {
        if (totalProductMoney >= data[i].money) item = data[i];
      }
      if (item?.discount) {
        Funcs.log('Promotion apply', item);
        const { unit, discount } = item;
        let discountValue = discount;
        if (unit !== discountType) {
          if (discountType === 0) discountValue = (discount / totalProductMoney) * 100;
          else if (discountType === 1) discountValue = (discount / 100) * totalProductMoney;
        }
        return { unit, discountValue, type };
      }
      return { discountValue: 0, type };
    } else if (type === Const.PROMOTION_TYPES.PGIFT) {
      const productGifts = [];
      for (let i = 0; i < data.length; i += 1) {
        const productGift = data[i];
        const product = selectedProducts?.find((e) => e.id === productGift.id);
        if (!product) continue;
        const { gifts = [] } = productGift;
        gifts.sort((a, b) => a.quantity - b.quantity);

        // Tìm gift phù hợp nhất
        let gift = null;
        for (let j = 0; j < gifts.length; j += 1) {
          if (product.amount >= gifts[j].quantity) gift = gifts[j];
        }
        const { id, unitId, productTypeId } = product;
        ////////////////////////////////////////////////////////////////// Lỗi khi có topping, phải tính tổng sảnn phẩm tặng quà tương ứng, hiện tại chỉ lấy cái gift đầu tiên
        if (gift) productGifts.push({ id, unitId, productTypeId, gift });
      }
      return { discountValue: 0, type, gifts: productGifts || [] };
    } else if (type === Const.PROMOTION_TYPES.OGIFT) {
      let item = null;
      data.sort((a, b) => a.money - b.money);
      for (let i = 0; i < data.length; i += 1) {
        if (totalProductMoney >= data[i].money) item = data[i];
      }
      return { discountValue: 0, type, gifts: item?.gifts || [] };
    }
    return {};
  },

  getMoneyText: ({ invoiceText, isSale, isImport, isReturn, type }) => {
    if (!invoiceText) invoiceText = Configs.billSettings.invoiceText || {};
    let tongTienDonHang = Lang.order.money;
    if (isSale && invoiceText?.totalMoney) tongTienDonHang = invoiceText?.totalMoney;
    let soTienDu = Lang.remainder;
    let soTienConNo = Lang.arrears;
    let soDuCu = Lang.totalOldReminder;
    let soTienKhachConDu = Lang.totalReminder;
    let soTienThanhToan = isImport || isReturn ? Lang.order.paid : Lang.order.totalPaidMoney;
    if (isSale && invoiceText?.paidMoney) soTienThanhToan = invoiceText?.paidMoney;
    let soTienKhachConNo = isImport ? Lang.debit : Lang.order.totalDebtMoney;
    if (isSale && invoiceText?.debtMoney) soTienKhachConNo = invoiceText?.debtMoney;
    if (isSale && invoiceText?.remainMoney) soTienKhachConDu = invoiceText?.remainMoney;
    let noCu = Lang.totalOldDebit;
    if (isSale && invoiceText?.oldDebt) noCu = invoiceText?.oldDebt;
    if (isSale && invoiceText?.oldBalance) soDuCu = invoiceText?.oldBalance;
    let tongPhaiThu = Lang.order.totalMustPaidMoney;
    let tongPhaiTraKhach = isImport ? Lang.remainder : Lang.order.totalMustPaidMoneyForCustomer;
    if (isSale && invoiceText?.mustPaidMoney) tongPhaiThu = invoiceText?.mustPaidMoney;
    if (isSale && invoiceText?.mustReturnMoney) tongPhaiTraKhach = invoiceText?.mustReturnMoney;

    // Check theo type
    if (type === RETURN) {
      soTienThanhToan = Lang.order.totalPaidMoneyForCustomer;
      soTienKhachConNo = Lang.order.totalLiabilities;
    }
    if (type === IMPORT_RETURN) {
      soTienThanhToan = Lang.order.providerRefunds;
      soTienKhachConNo = Lang.order.providerDebt;
    }
    return { tongTienDonHang, soTienDu, soTienConNo, soTienThanhToan, soTienKhachConNo, soTienKhachConDu, noCu, soDuCu, tongPhaiThu, tongPhaiTraKhach };
  },

  getOrderBreadCrumb: (type) => {
    let params = { text: Lang.order.title, path: '/dashboard/order' };
    if (type === Const.ORDER_TYPE.RETURN) {
      params.path = '/dashboard/return-order';
      params.text = Lang.menu.orderReturn;
    } else if (type === Const.ORDER_TYPE.IMPORT) {
      params.path = '/dashboard/import-order';
      params.text = Lang.importOrder.title;
    } else if (type === Const.ORDER_TYPE.IMPORT_RETURN) {
      params.path = '/dashboard/import-return';
      params.text = Lang.importReturnOrder.title;
    } else if ([Const.ORDER_TYPE.PAYMENT_VOUCHER, Const.ORDER_TYPE.RECIEPT, Const.ORDER_TYPE.DEBT].indexOf(type) >= 0) {
      params.path = '/dashboard/financial';
      params.text = Lang.stats.cashflow;
    }
    return params;
  }
};

export default OrderUtils;
